import category from '../Admin/Category/DisplayCategory';
import AddCategory from '../Admin/Category/AddCategory';
import EditCategory from '../Admin/Category/EditCategory';
import CategoryFilter from '../Admin/Category/CategoryFilter';

import skill from '../Admin/Skill/DisplaySkill';
import AddSkill from '../Admin/Skill/AddSkill';
import EditSkill from '../Admin/Skill/EditSkill';

import menu_permission from '../../middleware/menu_permission';
import helper_type from '../Admin/HelperType/DisplayHelperType';

import helper_master from '../Admin/HelperMaster/DisplayHelperMaster';
import AddHelperMaster from '../Admin/HelperMaster/AddHelperMaster';
import EditHelperMaster from '../Admin/HelperMaster/EditHelperMaster';

//5.Page not found

const routes = [
  {
    path: '/admin/denied',
    component: () => import('../Admin/UserManagement/permissionDenied'),
    name: 'permission_denied',
    props: true,
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => {
      if (typeof window !== 'undefined' && (!window.Permissions || !window.Permissions.length)) {
        return Promise.resolve({ render: h => h('admin-login') });
      }
      return import('../Admin/Dashboard/admindashboard');
    },

    meta: {
      permission: 'dashboard.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/hub/:section?',
    name: 'admin_hub',
    component: () => import('../Admin/Hub/AdminHubPage'),
    props: route => ({
      section: route.params.section || 'settings',
    }),
  },
  {
    path: '/admin/changepassword',
    component: () => import('../Admin/Dashboard/ChangePassword/updatePassword'),
    name: 'ChangePassword',
  },
  {
    path: '/admin/master/domain',
    component: () => import('../Admin/Domain/DisplayDomain'),
    name: 'domain',
    meta: {
      permission: 'dashboard.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/domain/add',
    component: () => import('../Admin/Domain/AddDomain'),
    name: 'AddDomain',
    meta: {
      permission: 'master.sector.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/domain/city/add',
    component: () => import('../Admin/Domain/City/Report.vue'),
    name: 'AddCity',
    // meta: {
    //     permission:'master.sector.',
    //     middleware: [ menu_permission ]
    // }
  },

  {
    path: '/admin/master/domain/city/id:id',
    component: () => import('../Admin/Domain/City/pagedesignreport.vue'),
    name: 'CityPagedesign',
    // meta: {
    //     permission:'master.sector.',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/master/domain/citypage/add:id',
    component: () => import('../Admin/Domain/City/addcitypage.vue'),
    name: 'AddCityPage',
    // meta: {
    //     permission:'master.sector.',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/master/domain/citypage/edit:id',
    component: () => import('../Admin/Domain/City/editcitypage.vue'),
    name: 'EditCityPage',
    // meta: {
    //     permission:'master.sector.',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/master/domain/edit:id',
    component: () => import('../Admin/Domain/EditDomain'),
    name: 'EditDomain',
    meta: {
      permission: 'master.sector.update',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/domain/meta_tag/id:id',
    component: () => import('../Admin/Domain/metaTagReport'),
    name: 'DomainMetaTag',
    meta: {
      permission: 'master.sector.metatag.report',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/master/domain/pagedesign/id/:id',
    component: () => import('../Admin/Domain/SectorPage/report'),
    name: 'PageDesign',
    meta: {
      permission: 'master.sector.metatag.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/domain/pagedesign/create/id/:id',
    component: () => import('../Admin/Domain/SectorPage/create'),
    name: 'PageDesignCreate',
    meta: {
      permission: 'master.sector.metatag.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/domain/Categorydesign/id/:id',
    component: () => import('../Admin/Category/CategoryPage/report'),
    name: 'CategoryDesign',
    meta: {
      permission: 'master.sector.metatag.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/domain/Categorydesign/create/id/:id',
    component: () => import('../Admin/Category/CategoryPage/create'),
    name: 'CategoryDesignCreate',
    meta: {
      permission: 'master.sector.metatag.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/domain/sectionmaster/id/:id/type/:type',
    component: () => import('../Admin/Domain/PageDesign/section/report'),
    name: 'sectionmaster',
    meta: {
      permission: 'master.sector.metatag.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/domain/sectionassest/id/:id/type/:type',
    component: () => import('../Admin/Domain/PageDesign/section_assest/report'),
    name: 'sectionassest',
    meta: {
      permission: 'master.sector.metatag.report',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/master/domain/faq/id:id',
    component: () => import('../Admin/Domain/faq'),
    name: 'DomainFaq',
    meta: {
      permission: 'master.sector.faq.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/category',
    component: category,
    name: 'category',
    meta: {
      permission: 'master.sector.category.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/category/add:id',
    component: AddCategory,
    name: 'AddCategory',
    meta: {
      permission: 'master.sector.category.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/category/category_filter:id',
    component: CategoryFilter,
    name: 'CategoryFilter',
    meta: {
      permission: 'master.sector.category.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/category/faq/id:id',
    component: () => import('../Admin/Category/faq'),
    name: 'CategoryFaq',
    meta: {
      permission: 'master.sector.category.faq_report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/category/metaTag/id:id',
    component: () => import('../Admin/Category/metaTag'),
    name: 'CategoryMetaTag',
    meta: {
      permission: 'master.sector.category.metatag_report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/category/edit:id',
    component: EditCategory,
    name: 'EditCategory',
    meta: {
      permission: 'master.sector.category.update',
      middleware: [menu_permission],
    },
  },
  //3.Setting obj for Skill
  {
    path: '/admin/master/skill',
    component: skill,
    name: 'skill',

    meta: {
      permission: 'master.skills.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/skill/add',
    component: AddSkill,
    name: 'AddSkill',
    meta: {
      permission: 'master.skills.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/skill/edit:id',
    component: EditSkill,
    name: 'EditSkill',
    meta: {
      permission: 'master.skills.update',
      middleware: [menu_permission],
    },
  },
  //4.Setting obj for Helper Type
  {
    path: '/admin/master/helper_type',
    component: helper_type,
    name: 'helper_type',
    meta: {
      permission: 'master.helper_type',
      middleware: [menu_permission],
    },
  },

  //5.Setting obj for Helper Master
  {
    path: '/admin/master/helper_master',
    component: helper_master,
    name: 'helper_master',

    meta: {
      permission: 'master.helper_master',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/helper_master/add',
    component: () => import('../Admin/HelperMaster/AddHelperMaster'),
    name: 'AddHelperMaster',
    meta: {
      permission: 'master.helper_master.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/EditMasterHelper/edit:id',
    component: () => import('../Admin/HelperMaster/EditHelperMaster'),
    name: 'EditHelperMaster',
    meta: {
      permission: 'master.helper_master.update',
      middleware: [menu_permission],
    },
  },
  //6. Setting for Delivery Time
  {
    path: '/admin/master/delivery_time',
    component: () => import('../Admin/DeliveryTime/DisplayDeliveryTime'),
    name: 'delivery_time',
    meta: {
      permission: 'master.delivery_time',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/delivery_time/add',
    component: () => import('../Admin/DeliveryTime/AddDeliveryTime'),
    name: 'AddDeliveryTime',
    meta: {
      permission: 'master.delivery_time.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/delivery_time/edit:id',
    component: () => import('../Admin/DeliveryTime/EditDeliveryTime'),
    name: 'EditDeliveryTime',
    meta: {
      permission: 'master.delivery_time.update',
      middleware: [menu_permission],
    },
  },

  //7. For Project Upgrades

  {
    path: '/admin/master/project_upgrade/add',
    component: () => import('../Admin/Projects/Upgrades/AddUpgrade.vue'),
    name: 'AddProjectUpgrade',
    // meta: {
    //   permission: 'master.helper_master.create',
    //   middleware: [menu_permission],
    // },
  },

  {
    path: '/admin/master/project_upgrade/edit/:id',
    component: () => import('../Admin/Projects/Upgrades/EditUpgrade.vue'),
    name: 'EditUpgrade',
    // meta: {
    //   permission: 'master.skills.update',
    //   middleware: [menu_permission],
    // },
  },

  {
    path: '/admin/master/project_upgrade/report',
    component: () => import('../Admin/Projects/Upgrades/DisplayUpgrades.vue'),
    name: 'UpgradeReport',

    // meta: {
    //   permission: 'master.skills.',
    //   middleware: [menu_permission],
    // },
  },
  //5.Setting obj for Helper Master
  {
    path: '/admin/users',
    component: () => import('../Admin/Users/DisplayUsers'),
    name: 'users',
    meta: {
      permission: 'talents.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/users/edit/:id',
    component: () => import('../Seller/SellerProfile/EditProfile'),
    name: 'EditUser',
    meta: {
      permission: 'talents.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/slider',
    component: () => import('../Admin/Slider/DisplaySlider'),
    name: 'slider',
    meta: {
      permission: 'master.slider.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/slider/add',
    component: () => import('../Admin/Slider/AddSlider'),
    name: 'AddSlider',
    meta: {
      permission: 'master.slider.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/slider/edit:id',
    component: () => import('../Admin/Slider/EditSlider'),
    name: 'EditSlider',
    meta: {
      permission: 'master.slider.update',
      middleware: [menu_permission],
    },
  },
  //7.Setting for add Notifications
  {
    path: '/admin/master/notification',
    component: () => import('../Admin/Notification/DisplayNotification'),
    name: 'Notification',
    meta: {
      permission: 'master.notification.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/notification',
    component: () => import('../Admin/Notification/ViewNotification'),
    name: 'newNotification',
    // meta: {
    //     permission:'master.notification.',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/master/notification/add',
    component: () => import('../Admin/Notification/AddNotification'),
    name: 'AddNotification',
    meta: {
      permission: 'master.notification.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/notification/edit',
    component: () => import('../Admin/Notification/EditNotification'),
    name: 'EditNotification',
    meta: {
      permission: 'master.notification.update',
      middleware: [menu_permission],
    },
  },
  //8.Setting for add cards
  {
    path: '/admin/master/card',
    component: () => import('../Admin/Card/DisplayCard'),
    name: 'card',
    meta: {
      permission: 'master.card.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/card/add',
    component: () => import('../Admin/Card/AddCard'),
    name: 'AddCard',
    meta: {
      permission: 'master.card.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/card/edit',
    component: () => import('../Admin/Card/EditCard'),
    name: 'EditCard',
    meta: {
      permission: 'master.card.update',
      middleware: [menu_permission],
    },
  },

  // =========== WhatsApp Events =============
  {
    path: '/admin/master/whatsapp_event',
    component: () => import('../Admin/WhatsAppEvents/report.vue'),
    name: 'whatsapp_event',
    meta: {
      permission: 'master.whatsapp_event.report',
      middleware: [menu_permission],
    },
  },
  // =========== WhatsApp Events =============
  //Admin/Bottominfo/DisplayBottominfo
  /////////////////Bottom info///////////////////////////
  {
    path: '/admin/master/bottominfo',
    component: () => import('../Admin/Bottominfo/DisplayBottominfo'),
    name: 'bottominfo',
    meta: {
      permission: 'master.bottom_info.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/bottominfo/add',
    component: () => import('../Admin/Bottominfo/AddBottominfo'),
    name: 'AddBottominfo',
    meta: {
      permission: 'master.bottom_info.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/bottominfo/edit:id',
    component: () => import('../Admin/Bottominfo/EditBottominfo'),
    name: 'EditBottominfo',
    meta: {
      permission: 'master.bottom_info.update',
      middleware: [menu_permission],
    },
  },

  /// Rate master add ///

  {
    path: '/admin/master/ratemaster',
    component: () => import('../Admin/Ratemaster/DisplayRatemaster'),
    name: 'ratemaster',
    meta: {
      permission: 'master.project_rate_master.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/terms_and_conditions',
    component: () => import('../Admin/terms_and_conditions/terms_and_condition.vue'),
    name: 'admin.terms_and_condition',
    // meta: {
    //     permission:'master.project_rate_master.',
    //     middleware: [ menu_permission ]
    // }
  },

  {
    path: '/admin/master/ratemaster/add',
    component: () => import('../Admin/Ratemaster/AddRatemaster'),
    name: 'AddRatemasterinfo',
    meta: {
      permission: 'master.project_rate_master.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/ratemaster/edit:id',
    component: () => import('../Admin/Ratemaster/EditRatemaster'),
    name: 'EditRatemasterinfo',
    meta: {
      permission: 'master.project_rate_master.update',
      middleware: [menu_permission],
    },
  },

  /// End rate master ////

  //Component Routes for Seller's Proposal Approval
  {
    path: '/admin/proposal/:status?',
    component: () => import('../Admin/Proposals/DisplayProposal'),
    name: 'ApproveProposal',
    props: true,
    meta: {
      permission: 'browse_and_buy.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/proposal/make_featured:id',
    component: () => import('../Admin/Proposals/MakeFeatured/featured'),
    name: 'MakeFeatured',
    meta: {
      permission: 'browse_and_buy.update',
      middleware: [menu_permission],
    },
  },

  //Component Routes for Proposal's Coupons
  {
    path: '/admin/coupons',
    component: () => import('../Admin/Coupons/DisplayCoupons'),
    name: 'Coupons',
    meta: {
      permission: 'coupons.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/coupons/add',
    component: () => import('../Admin/Coupons/AddCoupon'),
    name: 'AddCoupon',
    meta: {
      permission: 'coupons.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/coupons/edit:id',
    component: () => import('../Admin/Coupons/EditCoupon'),
    name: 'EditCoupon',
    meta: {
      permission: 'coupons.update',
      middleware: [menu_permission],
    },
  },

  //Component Routes for Support Ticket's Typs/Ticket Master
  {
    path: '/admin/support/ticket_master',
    component: () => import('../Admin/SupportTickets/TicketMaster/DisplayTicketType'),
    name: 'TicketMaster',
    meta: {
      permission: 'supports.ticket_master.',
      middleware: [menu_permission],
    },
  },
  //Component Routes for Support Ticket's Typs/Ticket Master
  {
    path: '/admin/support/subjects',
    component: () => import('../Admin/SupportTickets/SubjectMaster/DisplaySubjects'),
    name: 'Subjects',
    meta: {
      permission: 'supports.subject.',
      middleware: [menu_permission],
    },
  },

  //Component Routes for Support Settings Master
  {
    path: '/admin/support/support_settings',
    component: () => import('../Admin/SupportTickets/SupportSettings/DisplaySupportSettings'),
    name: 'SupportSettings',
    meta: {
      permission: 'supports.support_settings.',
      middleware: [menu_permission],
    },
  },
  //Component Routes for Support Status/Ticket Status Master
  {
    path: '/admin/support/ticket_status',
    component: () => import('../Admin/SupportTickets/TicketStatus/DisplayTicketStatus'),
    name: 'TicketStatus',
    meta: {
      permission: 'supports.ticket_status.',
      middleware: [menu_permission],
    },
  },

  //Component Routes for Tickets and Ticket Chats
  {
    path: '/admin/support/allTickets',
    component: () => import('../Admin/SupportTickets/Tickets/DisplayTickets'),
    name: 'AllTickets',
    meta: {
      permission: 'supports.view_tickets.',
      middleware: [menu_permission],
    },
  },
  // {
  //     path: '/admin/support_chat/:id',
  //     component: () => import('../Admin/SupportTickets/AdminTicketChat'),
  //     name: "AdminSupportChat",
  //     meta: {
  //         permission:'master.bottom_info.',
  //         middleware: [ menu_permission ]
  //     }
  // },
  {
    path: '/admin/support_chat/get/:id',
    component: () => import('../Admin/SupportTickets/AdminTicketConversion'),
    name: 'AdminSupportChat',
    meta: {
      permission: 'supports.chat.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/whatsappmessage/:lead_id',
    component: () => import('../Admin/Crm/detailPage/whatsappmessage.vue'),
    name: 'Whatsappmessagedata',
  },

  //Component Routes for Seller Level
  {
    path: '/admin/master/seller_level',
    component: () => import('../Admin/SellerLevel/DisplaySellerLevels'),
    name: 'SellerLevel',
    meta: {
      permission: 'master.seller_levels.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/global_alt',
    component: () => import('../Admin/GlobalAlt/GlobalAlt'),
    name: 'Global Alt',
    meta: {
      permission: 'master.global_alt',
      middleware: [menu_permission],
    },
  },

  //whatsapp template

  {
    path: '/admin/whatsapptemplate/:lead_id',
    component: () => import('../Admin/Crm/detailPage/template.vue'),
    name: 'TemplateModal',
    props: true,
  },

  //Component Routes for Seller Level
  {
    path: '/admin/master/seller_level',
    component: () => import('../Admin/SellerLevel/DisplaySellerLevels'),
    name: 'SellerLevel',
    meta: {
      permission: 'payment_settings.general_payment.',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/payment/general_setting',
    component: () => import('../Admin/PaymentSettings/generalPaymentSetting.vue'),
    name: 'GeneralSetting',
    meta: {
      permission: 'payment_settings.general_payment.',
      middleware: [menu_permission],
    },
  },
  //Component Routes for Seller Payment Settings
  {
    path: '/admin/payment/seller_payment_setting',
    component: () => import('../Admin/PaymentSettings/sellerPaymentSetting'),
    name: 'SellerPaymentSetting',
    meta: {
      permission: 'payment_settings.seller_payment.',
      middleware: [menu_permission],
    },
  },
  /// Project Section  ///
  {
    path: '/admin/project/:status?',
    component: () => import('../Admin/Projects/DisplayProject'),
    name: 'AllProject',
    props: true,
    meta: {
      permission: 'project.',
      middleware: [menu_permission],
    },
  },

  // Component Routes for All Orders
  {
    path: '/admin/orders',
    component: () => import('../Admin/Orders/AllOrders'),
    name: 'ViewOrders',
    meta: {
      permission: 'orders.',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/OrderDetails',
    component: () => import('../../components/Seller/Orders/orderdetail'),
    name: 'OrderDetailByAdmin',
    //work pending
    meta: {
      permission: 'orders.',
      middleware: [menu_permission],
    },
  },

  //...............Component Routes for Accounting ..........................
  {
    path: '/admin/sales',
    component: () => import('../Admin/Accounting/sales.vue'),
    name: 'Sales',
    meta: {
      permission: 'accounting.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/account/invoice_receipt/report',
    component: () => import('../Admin/Accounting/InvoiceReceipt.vue'),
    name: 'InvoiceReceipt',
    meta: {
      permission: 'accounting.invoice_receipt.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/account/tcs_and_tds/report',
    component: () => import('../Admin/Accounting/tcsandtdsreport.vue'),
    name: 'TcsAndTDSReport',
    meta: {
      permission: 'accounting.tcs_and_tds.report',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/account/gst/report',
    component: () => import('../Admin/Accounting/gstreport.vue'),
    name: 'GstReport',
    meta: {
      permission: 'accounting.gst.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/account/gst_refund/report',
    component: () => import('../Admin/Accounting/GstRefundReport.vue'),
    name: 'GSTRefund',
    meta: {
      permission: 'accounting.gst_refund.report',
      middleware: [menu_permission],
    },
  },
  //.........Routes for Cancellation Master .........
  {
    path: '/admin/master/cancellation_master',
    component: () => import('../Admin/CancellationMaster/cancellation_master'),
    name: 'CancellationMaster',
    meta: {
      permission: 'master.cancellation_reason.',
      middleware: [menu_permission],
    },
  },
  //.........Routes for Payouts .........
  {
    path: '/admin/payouts',
    component: () => import('../Admin/Payouts/payout.vue'),
    name: 'Payout',
    meta: {
      permission: 'payouts.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/refund',
    component: () => import('../Admin/Refund/refund.vue'),
    name: 'Refund',
    meta: {
      permission: 'payouts.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/search',
    component: () => import('../Admin/Searchuser/searchuser.vue'),
    name: 'searchuser',
    meta: {
      permission: 'payouts.',
      middleware: [menu_permission],
    },
  },

  //Component Routes for Trainings
  // {
  //     path: '/admin/training_class',
  //     component: () => import('../Admin/Training/DisplayTraining'),
  //     name: "ApproveTraining",
  // },

  {
    path: '/admin/trainers',
    component: () => import('../Admin/Training/DisplayTrainers.vue'),
    name: 'AllTrainers',
    meta: {
      permission: 'training.',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/tutors',
    component: () => import('../Admin/Training/DisplayTutors.vue'),
    name: 'AllTutors',
    meta: {
      permission: 'training.tutor.show',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/tutors/enrolled/:id',
    component: () => import('../Admin/Training/EnrolledStudent.vue'),
    name: 'EnrolledStudent',
    meta: {
      permission: 'training.class.enrolled_student.show',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/tutors/review/:id',
    component: () => import('../Admin/Training/Review/ClassReview.vue'),
    name: 'ClassReview',
    meta: {
      permission: 'training.class.review.show',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/class/preview/:id',
    component: () => import('../../components/Admin/Training/class_tutorDetails.vue'),
    name: 'courseDetail',
    meta: {
      permission: 'training.class.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/master/subscription_charges',
    component: () => import('../Admin/Training/SubscriptionMaster/subscriptionCharges.vue'),
    name: 'SubscriptionCharges',
    meta: {
      permission: 'master.subscription_charges.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/training_classes',
    component: () => import('../Training/Teacher/training_classes'),
    name: 'UserTrainingClasses',
    meta: {
      permission: 'master.bottom_info.',
      middleware: [menu_permission],
    },
  },

  //Component Routes for Trainings Sunscription Charges
  {
    path: '/admin/master/subscription_charges',
    component: () => import('../Admin/Training/SubscriptionMaster/subscriptionCharges.vue'),
    name: 'SubscriptionCharges',
    meta: {
      permission: 'master.subscription_charges.',
      middleware: [menu_permission],
    },
  },

  // Send Notification ///

  {
    path: '/admin/sendnotification',
    component: () => import('../Admin/Sendnotification/sendnotification.vue'),
    name: 'SendNotification',
    meta: {
      permission: 'notification_report.send',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/reportnotification',
    component: () => import('../Admin/Sendnotification/shownotification.vue'),
    name: 'ReportNotification',
    meta: {
      permission: 'notification_report.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/notificationuserlist/:id',
    component: () => import('../Admin/Sendnotification/notificationuserlist.vue'),
    name: 'NotificationUserList',
    meta: {
      permission: 'notification_report.view',
      middleware: [menu_permission],
    },
  },

  //-----------------------Hepls topics and Help Contents----------------- ///
  {
    path: '/admin/master/helps',
    component: () => import('../Admin/Helps/helps.vue'),
    name: 'Helps',
    meta: {
      permission: 'master.help_contents.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/helps/content:id',
    component: () => import('../Admin/Helps/HelpContents.vue'),
    name: 'HelpContent',
    meta: {
      permission: 'master.help_contents.',
      middleware: [menu_permission],
    },
  },

  // Coin Setup start  ///

  {
    path: '/admin/payment/coinsetup',
    component: () => import('../Admin/CoinSetup/coinsetups'),
    name: 'coinsetup',
    meta: {
      permission: 'payment_settings.coin_setup.',
      middleware: [menu_permission],
    },
  },
  // Coin Setup End  ///

  // {
  //     path:'/admin/subscribers',
  //     component : () => import('../Admin/Subscribers/allsubscribers'),
  //     name : "AllSubscribers",
  //     meta: {
  //         permission:'subscribers.',
  //         middleware: [ menu_permission ]
  //     }
  // },
  {
    path: '/admin/subscribers',
    component: () => import('../Admin/Subscribers/allsubscribers'),
    name: 'AllSubscribers',
    meta: {
      permission: 'subscribers.',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/reviews',
    component: () => import('../Admin/Reviews/review'),
    name: 'AllReviews',
    meta: {
      permission: 'reviews.',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/resource_master',
    component: () => import('../Admin/ResourceMaster/resourceMaster'),
    name: 'ResourceMaster',
    meta: {
      permission: 'resources.type.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/resources',
    component: () => import('../Admin/ResourceMaster/resources'),
    name: 'Resources',
    meta: {
      permission: 'resources.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/resources/add',
    component: () => import('../Admin/ResourceMaster/add_resources'),
    name: 'AddResources',
    meta: {
      permission: 'resources.create',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/resources/edit:id',
    component: () => import('../Admin/ResourceMaster/add_resources'),
    name: 'EditResources',
    meta: {
      permission: 'resources.update',
      middleware: [menu_permission],
    },
  },

  // {
  //     path: '/admin/user_management/menus',
  //     component: () => import('../Admin/UserManagement/MenuMaster'),
  //     name: 'AdminMenus',

  // },

  {
    path: '/admin/user/profile',
    component: () => import('../Seller/SellerProfile/EditProfile'),
    name: 'admin_profile',
  },

  {
    path: '/admin/user_management/roles',
    component: () => import('../Admin/UserManagement/AdminRoles'),
    name: 'AdminRoles',
    meta: {
      permission: 'user_management.roles.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/user_management/permission',
    component: () => import('../Admin/UserManagement/AssignPermissions'),
    name: 'AdminPermission',
    props: true,
    meta: {
      permission: 'user_management.permission.',
      middleware: [menu_permission],
    },
  },
  // {
  //     path: '/admin/user_management/add_user/:id?',
  //     component: () => import('../Admin/UserManagement/AddUser'),
  //     name: 'AddUser',

  // },
  {
    path: '/admin/user_management/user_with_role',
    component: () => import('../Admin/UserManagement/UserWithRoles'),
    name: 'userWithRole',
    meta: {
      permission: 'user_management.user_with_role.',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/user_management/add_user_permission',
    component: () => import('../Admin/UserManagement/AddUserPermission'),
    name: 'addUserPermission',
    meta: {
      permission: 'user_management.add_permission.',
      middleware: [menu_permission],
    },
  },
  //admin Global settings
  {
    path: '/admin/global_settings/email/email_setup',
    component: () => import('../Admin/Email/EmailSetup'),
    name: 'EmailSetup',
    meta: {
      permission: 'global_settings.email.email_setup.',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/global_settings/email/email_template',
    component: () => import('../Admin/Email/EmailTemplate'),
    name: 'EmailTemplate',
    meta: {
      permission: 'global_settings.email.email_template.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/images',
    component: () => import('../Admin/Email/uploadimage'),
    name: 'UploadImage',
    meta: {
      permission: 'global_settings.email.email_template.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/global_settings/project_event',
    component: () => import('../Admin/Event/ProjectEvent'),
    name: 'ProjectEvent',
    meta: {
      permission: 'global_settings.project_event.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/global_settings/automation/email_automation',
    component: () => import('../Admin/Email/EmailAutomation'),
    name: 'EmailAutomation',
    meta: {
      permission: 'global_settings.automation.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/landing-page/page',
    component: () => import('../Admin/LandingPageMaster/landingPage'),
    name: 'LandingPageMaster',
    meta: {
      permission: 'landing_page.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/seo/url_redirect',
    component: () => import('../Admin/seo/url_redirect.vue'),
    name: 'UrlRedirect',
    meta: {
      permission: 'url_redirect.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/landing-page/page-metas',
    component: () => import('../Admin/LandingPageMaster/pageMetas'),
    name: 'PageMetasMaster',
    props: true,
    meta: {
      permission: 'landing_page.meta.',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/seo/front_pages',
    component: () => import('../Admin/seo/front_pages'),
    name: 'FrontPages',
    props: true,
    meta: {
      permission: 'front_page.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/seo/micro_jobs',
    component: () => import('../Admin/seo/micro_job_seo'),
    name: 'MicroJobSeo',
    meta: {
      permission: 'micro_job_seo.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/seo/front_page_seo',
    component: () => import('../Admin/seo/front_page_seo'),
    name: 'FrontPageSeo',
    props: true,
    meta: {
      permission: 'front_page.meta_tags.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/user/report/bids',
    component: () => import('../Admin/UserReport/bidByUser'),
    name: 'freelancerBidReport',
    props: true,
    meta: {
      permission: 'talents.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/user/report/projects/:id',
    component: () => import('../Admin/UserReport/clientProjectReport'),
    name: 'clientProjectReport',
    props: true,
    meta: {
      permission: 'talents.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/project/report/bids/:id',
    component: () => import('../Admin/UserReport/projectBids'),
    name: 'projectBidsReport',
    props: true,
    meta: {
      permission: 'project.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/zoop_buy/sub_report/:id',
    component: () => import('../Admin/UserReport/zoopbuy_subreport'),
    name: 'zoopbuysubReport',
    props: true,
    meta: {
      permission: 'project.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/crm/payout_report',
    component: () => import('../Admin/Crm/payoutReport'),
    name: 'payout_report',
    props: true,
    meta: {
      permission: 'crm.payout_report',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/crm/leads_analytics',
    component: () => import('../Admin/Crm/Leads Analytics/leadsAnalytics'),
    name: 'leads_analytics',
    meta: {
      permission: 'crm.leads_analytics',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/email_send',
    component: () => import('../Admin/Crm/emailSend'),
    name: 'crm_email_send',
    props: true,
    meta: {
      permission: 'crm.email_send_user',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/bde_report',
    component: () => import('../Admin/Crm/bde_report'),
    name: 'bde_report',
    props: true,
    meta: {
      permission: 'crm.bde.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/report',
    component: () => import('../Admin/Crm/report'),
    name: 'crmReport',
    props: true,
    meta: {
      permission: 'crm.lead.view',
      middleware: [menu_permission],
    },
  },
  // {
  //     path:'/admin/crm/lead/create',
  //     component:()=>import('../Admin/Crm/createLead'),
  //     name:'crmLeadCreate',
  //     props:true,
  //     meta: {
  //         permission:'crm.lead.manual_create',
  //         middleware: [ menu_permission ]
  //     },

  // },
  {
    path: '/admin/crm/detail/:id',
    component: () => import('../Admin/Crm/leadDetails'),
    name: 'CrmLeadDetails',
    props: true,
    meta: {
      permission: 'crm.lead.detail',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/crm/leads_analytics',
    component: () => import('../Admin/Crm/Leads Analytics/leadsAnalytics'),
    name: 'leads_analytics',
    meta: {
      permission: 'crm.leads_analytics',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/email_send',
    component: () => import('../Admin/Crm/emailSend'),
    name: 'crm_email_send',
    props: true,
    meta: {
      permission: 'crm.email_send_user',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/bde_report',
    component: () => import('../Admin/Crm/bde_report'),
    name: 'bde_report',
    props: true,
    meta: {
      permission: 'crm.bde.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/report',
    component: () => import('../Admin/Crm/report'),
    name: 'crmReport',
    props: true,
    meta: {
      permission: 'crm.lead.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/crm/whatsapp/templates',
    component: () => import('../Admin/Crm/whatsapp/templates/index'),
    name: 'whatsapptemplates',
    props: true,
    meta: {
      permission: 'crm.lead.view',
      middleware: [menu_permission],
    },
  },
  // {
  //     path:'/admin/crm/lead/create',
  //     component:()=>import('../Admin/Crm/createLead'),
  //     name:'crmLeadCreate',
  //     props:true,
  //     meta: {
  //         permission:'crm.lead.manual_create',
  //         middleware: [ menu_permission ]
  //     },

  // },
  {
    path: '/admin/crm/detail/:id',
    component: () => import('../Admin/Crm/leadDetails'),
    name: 'CrmLeadDetails',
    props: true,
    meta: {
      permission: 'crm.lead.detail',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/master/leadstatus',
    component: () => import('../Admin/Crm/Master/leadStatus'),
    name: 'crmLeadStatus',
    // props:true,
    meta: {
      permission: 'crm.master.status.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/master/leadsource',
    component: () => import('../Admin/Crm/Master/leadSources'),
    name: 'crmLeadSource',
    // props:true,
    meta: {
      permission: 'crm.master.source.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/master/leadcampaign',
    component: () => import('../Admin/Crm/Master/leadCampaigns'),
    name: 'crmLeadCampaign',
    // props:true,
    meta: {
      permission: 'crm.master.campaign.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/login-log',
    component: () => import('../Admin/Crm/Master/loginLog'),
    name: 'crmLoginLog',
    props: true,
    meta: {
      permission: 'crm.master.loginLog.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/Logs/log_activitiy',
    component: () => import('../Admin/Logs/log_activities'),
    name: 'logactivity',
    props: true,
    // meta: {
    //     permission:'crm.master.loginLog.view',
    //     middleware: [ menu_permission ]
    // },
  },

  {
    path: '/admin/crm/master/defaultuser',
    component: () => import('../Admin/Crm/Master/defaultRepresentative'),
    name: 'crmDefaultUser',
    props: true,
    meta: {
      permission: 'crm.master.campaign.',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/activeuser',
    component: () => import('../Admin/Crm/activeUser'),
    name: 'crmActiveUser',
    // props:true,
    meta: {
      permission: 'crm.activeuser.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/setting/landingpage',
    component: () => import('../Admin/LandingPageContent/landing'),
    name: 'LandingPageContent',
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  //Enterprise

  {
    path: '/admin/setting/enterprisepagecontent',
    component: () => import('../Admin/Enterprise/enterprisepagecontent'),
    name: 'EnterprisePageContent',
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/enterprisepage',
    component: () => import('../Admin/Enterprise/enterprisepage'),
    name: 'EnterprisePage',
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/faq/create',
    name: 'FaqCreate',
    component: () => import('../Admin/Enterprise/faq_create.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/faq/report',
    name: 'FaqReport',
    component: () => import('../Admin/Enterprise/faq_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/faq/edit/:id',
    name: 'FaqEdit',
    component: () => import('../Admin/Enterprise/faq_edit.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/testimonial/create',
    name: 'TestimonialCreate',
    component: () => import('../Admin/Enterprise/testimonial_create.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/testimonial/report',
    name: 'TestimonialReport',
    component: () => import('../Admin/Enterprise/testimonial_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/testimonial/edit/:id',
    name: 'TestimonialEdit',
    component: () => import('../Admin/Enterprise/testimonial_edit.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/layout/report',
    name: 'LayoutReport',
    component: () => import('../Admin/Enterprise/layout_order.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/category/create',
    name: 'CategoryCreate',
    component: () => import('../Admin/Enterprise/category_create.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/category/report',
    name: 'CategoryReport',
    component: () => import('../Admin/Enterprise/category_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/category/edit/:id',
    name: 'CategoryEdit',
    component: () => import('../Admin/Enterprise/category_edit.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  //Ticker Enterprise

  {
    path: '/admin/setting/ticker/create',
    name: 'tickerCreate',
    component: () => import('../Admin/Enterprise/ticker_create.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/ticker/report',
    name: 'tickerReport',
    component: () => import('../Admin/Enterprise/ticker_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/tikcer/edit/:id',
    name: 'tickerEdit',
    component: () => import('../Admin/Enterprise/ticker_edit.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/industry/create',
    name: 'IndustryCreate',
    component: () => import('../Admin/Enterprise/Industry/industry_create.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/industry/edit/:id',
    name: 'IndustryEdit',
    component: () => import('../Admin/Enterprise/Industry/industry_edit.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/industry/report',
    name: 'IndustryReport',
    component: () => import('../Admin/Enterprise/Industry/industry_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/footerContent/create',
    name: 'FooterContentCreate',
    component: () => import('../Admin/Enterprise/Footer/footercontent_create.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/footerContent/edit/:id',
    name: 'FooterContentEdit',
    component: () => import('../Admin/Enterprise/Footer/footercontent_edit.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/footerContent/report',
    name: 'FooterContentReport',
    component: () => import('../Admin/Enterprise/Footer/footercontent_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/blog-casestudy/create',
    name: 'BlogCasestudyCreate',
    component: () => import('../Admin/Enterprise/BlogCasestudy/blog_casestudy_create.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/blog-casestudy/edit/:id',
    name: 'BlogCasestudyEdit',
    component: () => import('../Admin/Enterprise/BlogCasestudy/blog_casestudy_edit.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/blog-casestudy/report',
    name: 'BlogCasestudyReport',
    component: () => import('../Admin/Enterprise/BlogCasestudy/blog_casestudy_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/audit/report',
    name: 'AuditReport',
    component: () => import('../Admin/Enterprise/audit_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/setting/enquiry/report',
    name: 'EnquiryReport',
    component: () => import('../Admin/Enterprise/enquiry_report.vue'),
    props: true,
    meta: {
      permission: 'newlandingpage.master.view',
      middleware: [menu_permission],
    },
  },
  //login log users

  {
    path: '/admin/crm/call/logs',
    component: () => import('../Admin/Crm/callLogs'),
    name: 'crmCallLogs',
    props: true,
    meta: {
      permission: 'crm.call_logs.view',
      middleware: [menu_permission],
    },
  },
  // lead summary
  {
    path: '/admin/crm/summary',
    component: () => import('../Admin/Crm/summary'),
    name: 'crmSummary',
    meta: {
      permission: 'crm.summary',
      middleware: [menu_permission],
    },
  },
  //lead remark
  {
    path: '/admin/crm/master/remarks',
    component: () => import('../Admin/Crm/Master/remarks.vue'),
    name: 'crmLeadRemark',
    meta: {
      permission: 'crm.master.remark',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/crm/monitor/chatbox',
    component: () => import('../Admin/Crm/DataMonitor/ChatBox'),
    name: 'chatBoxMonitor',
    meta: {
      permission: 'data_monitor.chat.get',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/crm/monitor/project_bid/:id?',
    component: () => import('../Admin/Crm/DataMonitor/bids.vue'),
    name: 'ProjectBidMonitor',
    meta: {
      permission: 'data_monitor.bid.get',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/monitor/project_bid/:project_slug/:user_name',
    component: () => import('../Admin/Crm/DataMonitor/BidDetails.vue'),
    name: 'ProjectBidDetails',
    meta: {
      permission: 'data_monitor.bid.details',
      middleware: [menu_permission],
    },
  },

  //just for testing
  {
    path: '/admin/crm/call/users',
    component: () => import('../Admin/Crm/myOperatorUser'),
    name: 'crmCallUsers',
    // props:true,
    // meta: {
    //     permission:'crm.master.campaign.',
    //     middleware: [ menu_permission ]
    // },
  },

  {
    path: '/admin/city/pagemaster',
    component: () => import('../Admin/City Master/Report.vue'),
    name: 'ReportCityPageMaster',
    // meta: {
    //     permission:'master.sector.',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/city/pagemaster/create/:id?',
    component: () => import('../Admin/City Master/Create.vue'),
    name: 'CreateCityPageMaster',
    // meta: {
    //     permission:'master.sector.',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/city/pagemaster/faq/:id',
    component: () => import('../Admin/City Master/FAQ/Report.vue'),
    name: 'CityFaq',
    // meta: {
    //     permission:'master.sector.',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/city/pagemaster/meta_tag/:id',
    component: () => import('../Admin/City Master/meta_tag/meta.vue'),
    name: 'city_pagemaster_meta',
    // meta: {
    //     permission:'master.sector.',
    //     middleware: [ menu_permission ]
    // }
  },

  {
    path: '/admin/master/global/faq',
    component: () => import('../Admin/globle_faq/report.vue'),
    name: 'globle_faq_master',
    meta: {
      permission: 'master.globle_faq.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/master/global/faq/details/:id',
    component: () => import('../Admin/globle_faq_details/report.vue'),
    name: 'globle_faq_details_master',
    meta: {
      permission: 'master.globle_faq_detail.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/globalmeta',
    component: () => import('../Admin/GlobalMeta/report.vue'),
    name: 'globalmeta',
    meta: {
      permission: 'master.globalmeta.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/globalmeta/details/:id',
    component: () => import('../Admin/GlobalMeta/Details/report.vue'),
    name: 'globalmetadetails',
    meta: {
      permission: 'master.globalMetaDetail.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/category/bulk_upload',
    component: () => import('../Admin/Category/bulkUploadOnCategory.vue'),
    name: 'bulkUploadOnCategory',
    meta: {
      permission: 'master.category.bulk_upload_store',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/crm/bulk_uploadlead',
    component: () => import('../Admin/Crm/uploadbulklead.vue'),
    name: 'bulkUploadOnLead',
  },

  {
    path: '/admin/category/bulk_upload_report',
    component: () => import('../Admin/Category/bulkUploadRecord.vue'),
    name: 'bulkUploadRecord',
    meta: {
      permission: 'master.category.bulk_upload_report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/category/global_faq/update',
    component: () => import('../Admin/Category/bulkCategoryFaqUpdate.vue'),
    name: 'bulkCategoryGlobalFaqUpdate',
    // meta: {
    //     permission:'master.category.bulk_upload_report',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/category/CrossFunctionUpdate',
    component: () => import('../Admin/Category/CrossFunctionUpdate.vue'),
    name: 'CrossFunctionUpdate',
  },
  {
    path: '/admin/category/global_metatag/update',
    component: () => import('../Admin/Category/bulkCategoryMetaTagUpdate.vue'),
    name: 'bulkCategoryMetaTagUpdate',
    // meta: {
    //     permission:'master.category.bulk_upload_report',
    //     middleware: [ menu_permission ]
    // }
  },
  {
    path: '/admin/category/bulk_upload_report/edit/:id',
    component: () => import('../Admin/Category/bulkUploadOnCategoryEdit.vue'),
    name: 'bulkUploadEdit',
  },
  {
    path: '/admin/crm/deactivated_account_report',
    component: () => import('../Admin/Crm/DeactivatedAccountReport'),
    name: 'deactivated_account_report',
    props: true,
    meta: {
      permission: 'crm.deactivated_account_report',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/accounting/platformchargereport',
    component: () => import('../Admin/Accounting/platformchargereport.vue'),
    name: 'platformchargereport',
    props: true,
    meta: {
      permission: 'accounting.platformcharge.report',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/report/receipt',
    component: () => import('../Admin/Reports/Receipt/receipt.vue'),
    name: 'receiptreport',
    meta: {
      permission: 'reports.receipt',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/report/tds',
    component: () => import('../Admin/Reports/tds/tds.vue'),
    name: 'tdsreport',
    meta: {
      permission: 'reports.tds',
      middleware: [menu_permission],
    },
  },

  {
    path: '/admin/report/invoice',
    component: () => import('../Admin/Reports/Invoice/invoice.vue'),
    name: 'invoicereport',
    meta: {
      permission: 'reports.invoice',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/social/new_feature',
    component: () => import('../Admin/Social/NewFeature/report.vue'),
    name: 'social.new_feature.report',
    meta: {
      permission: 'social.new_feature.report',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/social/new_feature/create',
    component: () => import('../Admin/Social/NewFeature/create.vue'),
    name: 'social.new_feature.create',
    meta: {
      permission: 'social.new_feature.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/admin/social/new_feature/update/:id',
    component: () => import('../Admin/Social/NewFeature/update.vue'),
    name: 'social.new_feature.update',
    meta: {
      permission: 'social.new_feature.update',
      middleware: [menu_permission],
    },
  },
];
export default routes;
